import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "This is how confident you said you were:", -1)
const _hoisted_3 = { class: "text-base p-3 my-2" }
const _hoisted_4 = { class: "font-robotoBold" }
const _hoisted_5 = { class: "mb-8" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "mb-8" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "mb-8" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 1,
  class: "flex"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Reactivate challenge ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Reactivate ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " Download challenge ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Download ", -1)
const _hoisted_26 = { class: "flex justify-end items-center py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChallengeNavigation = _resolveComponent("ChallengeNavigation")!
  const _component_ChallengeHeader = _resolveComponent("ChallengeHeader")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AutoResizeTextarea = _resolveComponent("AutoResizeTextarea")!
  const _component_FaceUnhappyIcon = _resolveComponent("FaceUnhappyIcon")!
  const _component_FaceNeutralIcon = _resolveComponent("FaceNeutralIcon")!
  const _component_FaceHappyIcon = _resolveComponent("FaceHappyIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_Ribbon = _resolveComponent("Ribbon")!
  const _component_Download = _resolveComponent("Download")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_GuidedTour = _resolveComponent("GuidedTour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_ChallengeNavigation),
        _createVNode(_component_ChallengeHeader, { "is-editable": false }),
        (_ctx.confidenceLevel && _ctx.confidenceLevel !== -1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_3, [
                  _createTextVNode(" Confidence level: "),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.confidenceLevel) + "% ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
                  default: _withCtx(() => [
                    (_ctx.challengeIsActive)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_6, "How do you feel about that now?"))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_7, "Your reflections"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_AutoResizeTextarea, {
                  modelValue: _ctx.inputReflection,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputReflection) = $event)),
                  class: "input",
                  readonly: _ctx.challengeIsResolved,
                  rows: 5,
                  "max-rows": 10,
                  placeholder: "Reflect on how confident you were and what you now know"
                }, null, 8, ["modelValue", "readonly"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
            default: _withCtx(() => [
              (_ctx.challengeIsActive)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_9, "How well did your solution work?"))
                : (_openBlock(), _createElementBlock("h3", _hoisted_10, "Your solution rating"))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "group",
              disabled: _ctx.challengeIsResolved,
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => _ctx.setRating(1), ["prevent"]))
            }, [
              _createVNode(_component_FaceUnhappyIcon, {
                class: _normalizeClass(["fill-current transition duration-300", {
              'text-cebai-grey-mid': !_ctx.inputRating || _ctx.inputRating !== 1,
              'group-hover:text-cebai-grey-dark':
                !_ctx.inputRating || (_ctx.inputRating !== 1 && _ctx.challengeIsActive),
              'text-cebai-primary': _ctx.inputRating === 1,
            }])
              }, null, 8, ["class"])
            ], 8, _hoisted_12),
            _createElementVNode("button", {
              class: "group",
              disabled: _ctx.challengeIsResolved,
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.setRating(2), ["prevent"]))
            }, [
              _createVNode(_component_FaceNeutralIcon, {
                class: _normalizeClass(["fill-current transition duration-300", {
              'text-cebai-grey-mid': !_ctx.inputRating || _ctx.inputRating !== 2,
              'group-hover:text-cebai-grey-dark':
                !_ctx.inputRating || (_ctx.inputRating !== 2 && _ctx.challengeIsActive),
              'text-cebai-primary': _ctx.inputRating === 2,
            }])
              }, null, 8, ["class"])
            ], 8, _hoisted_13),
            _createElementVNode("button", {
              class: "group",
              disabled: _ctx.challengeIsResolved,
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.setRating(3), ["prevent"]))
            }, [
              _createVNode(_component_FaceHappyIcon, {
                class: _normalizeClass(["fill-current transition duration-300", {
              'text-cebai-grey-mid': !_ctx.inputRating || _ctx.inputRating !== 3,
              'group-hover:text-cebai-grey-dark':
                !_ctx.inputRating || (_ctx.inputRating !== 3 && _ctx.challengeIsActive),
              'text-cebai-primary': _ctx.inputRating === 3,
            }])
              }, null, 8, ["class"])
            ], 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
            default: _withCtx(() => [
              (_ctx.challengeIsActive)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_16, "What do you think went well?"))
                : (_openBlock(), _createElementBlock("h3", _hoisted_17, "What went well"))
            ]),
            _: 1
          }),
          _createVNode(_component_AutoResizeTextarea, {
            id: "input-positives",
            modelValue: _ctx.inputPositives,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputPositives) = $event)),
            class: "input",
            readonly: _ctx.challengeIsResolved,
            rows: 5,
            "max-rows": 10,
            placeholder: "Reflect on what worked well with your solution to resolve the challenge"
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_Editorial, { class: "w-full sm:w-auto" }, {
            default: _withCtx(() => [
              (_ctx.challengeIsActive)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_19, "What do you think didn't go so well?"))
                : (_openBlock(), _createElementBlock("h3", _hoisted_20, "What didn't go so well"))
            ]),
            _: 1
          }),
          _createVNode(_component_AutoResizeTextarea, {
            modelValue: _ctx.inputNegatives,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputNegatives) = $event)),
            class: "input",
            readonly: _ctx.challengeIsResolved,
            rows: 5,
            "max-rows": 10,
            placeholder: "Reflect on what you could improve next time with your solution to resolve the challenge"
          }, null, 8, ["modelValue", "readonly"])
        ]),
        (_ctx.challengeIsResolved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_AppButton, {
                id: "button-reactivate",
                type: "secondary",
                class: "mr-2",
                onClick: _ctx.handleReactivateChallenge
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_AppButton, {
                type: "secondary",
                onClick: _ctx.showDownloadModal
              }, {
                iconBefore: _withCtx(() => [
                  _createVNode(_component_DownloadIcon, { class: "stroke-current stroke-[1.5px] mr-1 sm:mr-2" })
                ]),
                default: _withCtx(() => [
                  _hoisted_24,
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Ribbon, {
      class: "mt-16",
      "ribbon-type": "primary"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.challengeIsResolved)
            ? (_openBlock(), _createBlock(_component_AppButtonRouterLink, {
                key: 0,
                type: "primary",
                to: { name: 'saved-challenges-tab', params: { slug: 'resolved' } }
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" View resolved challenges ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_AppButton, {
                key: 1,
                id: "button-resolve-challenge",
                type: "primary",
                disabled: _ctx.submitIsDisabled,
                onClick: _ctx.handleFormSubmit
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Resolve Challenge ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.download,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShown.download) = $event)),
      close: () => _ctx.closeModal('download')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('download'),
          title: "Download challenge"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Download, {
              ideas: _ctx.solutionIdeas,
              "output-type": "plan",
              "close-modal": () => _ctx.closeModal('download')
            }, {
              title: _withCtx(() => [
                _createTextVNode(" How would you like to download your plan? ")
              ]),
              _: 1
            }, 8, ["ideas", "close-modal"])
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"]),
    _createVNode(_component_GuidedTour, { name: "challenge-resolution" })
  ], 64))
}